import { HttpClient, HttpClientRequest, HttpClientResponse } from '@effect/platform';
import { isEnvVarOn, MarketsData } from '@silo/types';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Effect, pipe } from 'effect';

export const marketsDataKey = 'marketsData';

const isCypress = isEnvVarOn(() => process.env.NEXT_PUBLIC_IS_CYPRESS);

type MarketsDataKey = [key: typeof marketsDataKey];

/**
 * The cypress e2e tests rely on the markets data being fresh, so we are fetching the markets data client-side.
 */
export function useQueryMarketsData() {
  return useQuery({
    queryKey: [marketsDataKey],
    queryFn: queryMarketsData,
    enabled: isCypress,
    refetchOnMount: true,
  });
}

const queryMarketsData: QueryFunction<MarketsData, MarketsDataKey> = async () => {
  const marketsData = await pipe(
    HttpClientRequest.get('./api/display-markets'),
    HttpClient.fetchOk,
    Effect.andThen(HttpClientResponse.schemaBodyJson(MarketsData)),
    Effect.scoped,
    Effect.runPromise
  );

  return marketsData;
};
